import { graphql, useStaticQuery } from 'gatsby'

import type { FeatureToggleQueryQuery } from '@generated/graphql'

type GenericObject = { [key: string]: boolean }

const useCmsFeatureToggle = () => {
  const data = useStaticQuery<FeatureToggleQueryQuery>(graphql`
    query FeatureToggleQuery {
      cmsFeatureToggle {
        sections {
          name
          data
        }
      }
    }
  `)

  const { hasPaymentMethods, ...featureToggle }: GenericObject = data
    ?.cmsFeatureToggle?.sections?.[0]?.data || { hasPaymentMethods: [] }

  return { hasPaymentMethods, featureToggle }
}

export default useCmsFeatureToggle
